module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/wedding-desktop@3x-e0f36d4c816dc696c7c7d693d2a871ea.jpg";